.navHeader {
    line-height: 24px;
    padding-left: 24px;
    margin: 45px 0px 36px 0px;
}
